import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Navbar from "./components/Navbar";
import ErrorBoundary from "./components/ErrorBoundary";
import CookieConsent from "react-cookie-consent";
import "./components/CookieConsent.css";
import { Link } from "react-router-dom";

// Lazy load components for better performance
const Hero = lazy(() => import("./components/Hero"));
const Services = lazy(() => import("./components/Services"));
const WhyChoose = lazy(() => import("./components/WhyChoose"));
const Kontakt = lazy(() => import("./components/Kontakt").then(module => ({ default: module.Kontakt })));
const UpravljanjeSmjestajem = lazy(() => import("./components/UpravljanjeSmjestajem"));
const CleaningService = lazy(() => import("./components/CleaningService"));
const HouseMaster = lazy(() => import("./components/HouseMaster"));
const Privacy = lazy(() => import("./components/Privacy"));
const CleaningPage = lazy(() => import("./CleaningPage"));

// Loading component
const LoadingSpinner = () => (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50vh"
  }}>
    <div style={{
      width: "50px",
      height: "50px",
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #f7c873",
      borderRadius: "50%",
      animation: "spin 1s linear infinite"
    }}></div>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <a href="#main-content" className="skip-to-main">
          Preskoči na glavni sadržaj
        </a>
        <Navbar />
        <main id="main-content">
          <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route
              path="/"
              element={<UpravljanjeSmjestajem />}
            />
            <Route
              path="/upravljanje-smjestajem"
              element={<UpravljanjeSmjestajem />}
            />
            <Route path="/cleaningservice" element={<CleaningPage />} />
            <Route path="/hero" element={<Hero />} />
            <Route path="/housemaster" element={<HouseMaster />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          </Suspense>
        </main>
      {/* ✅ Cookie Banner */}
      <CookieConsent
        location="bottom"
        buttonText="Prihvaćam"
        declineButtonText="Odbijam"
        enableDeclineButton
        cookieName="cookieSuglasnost"
        style={{
          background: "#2B373B",
          color: "#fff",
          textAlign: "left",
          padding: "2px",
          fontSize: "15px",
        }}
        buttonStyle={{
          background: "#f7c873",
          color: "#000",
          fontSize: "14px",
          borderRadius: "5px",
          padding: "8px 16px",
          marginRight: "10px",
        }}
        declineButtonStyle={{
          background: "#ccc",
          color: "#000",
          fontSize: "14px",
          borderRadius: "5px",
          padding: "8px 16px",
        }}
        overlay
      >
        Ova stranica koristi kolačiće za poboljšanje funkcionalnosti i analizu
        prometa. Korištenjem stranice pristajete na upotrebu kolačića.{" "}
        <Link
          to="/privacy"
          style={{
            color: "#f7c873",
            textDecoration: "underline",
            marginLeft: "8px",
          }}
        >
          Više informacija
        </Link>
      </CookieConsent>
        <footer className="app-footer" role="contentinfo">
          <div className="footer-container">
            <div className="footer-section footer-about">
              <h3 className="footer-title">Dodo upravljanje nekretninama</h3>
              <p className="footer-text">
                Profesionalno vođenje vila, apartmana i kuća za odmor na otoku Krku.
              </p>
            </div>
            
            <div className="footer-section footer-business">
              <h4 className="footer-subtitle">Podaci o obrtu</h4>
              <p className="footer-text">
                <strong>DODO</strong>
                <br />
                Obrt za usluge, proizvodnju i oglašavanje
                <br />
                <br />
                <strong>Vlasnik:</strong> Dominik Poznić
                <br />
                <strong>Adresa:</strong> Pinezići, Potok 11
              </p>
            </div>
            
            <div className="footer-section footer-contact">
              <h4 className="footer-subtitle">Kontakt</h4>
              <p className="footer-text">
                <a href="tel:+385976069465" className="footer-link">
                  +385 97 606 9465
                </a>
                <br />
                <a href="mailto:dodonekretnine1@gmail.com" className="footer-link">
                  dodonekretnine1@gmail.com
                </a>
              </p>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p className="footer-copyright">
              © 2025 Dodo upravljanje nekretninama. Sva prava pridržana.
            </p>
            <p className="footer-design">
              Design by:{" "}
              <a
                href="https://www.s3le.com.hr"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-design-link"
                aria-label="S3le Web Design (otvara se u novom prozoru)"
              >
                S3le Web Design
              </a>
            </p>
          </div>
        </footer>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
